module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"back":"Eiti į pagrindinį puslapį","notFound":"Puslapis nerastas"}}')
  delete Component.options._Ctor
}
